import React from "react";
import "./App.css";
import MainPage from "./components/Main";


function App() {
    return (
        <div className="App">
            <MainPage />
        </div>
    );
}

export default App;
